import { api } from '..'
import { TLoraDeviceList, TLoraDeviceListItem } from 'shared/types'
import { usePaginatedQuery } from 'hooks/usePaginatedQuery'

export const getLoraDeviceList = async (params?: Record<string, string>) => {
  return api
    .get<TLoraDeviceList>('/v1/lorawan/devices', { params })
    .then(({ data }) => data)
}

export const loraDeviceListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getLoraDeviceList(params),
  queryKey: ['loraDevices', params],
  refetchInterval: 30 * 1000,
})

export const useGetLoraDevicesList = () =>
  usePaginatedQuery(loraDeviceListQuery)
